// ═══════════════════════════════════════════════════════════════════════════════
// LANDING.JS - Entry point для публичной landing страницы (monkeymachine.ru/)
// ═══════════════════════════════════════════════════════════════════════════════
//
// Этот файл собирается через esbuild в один бандл.
// Используется вместо importmap для публичных страниц.
//
// Команды:
//   npm run build         - production build (все бандлы)
//   npm run build:landing - только landing
//   npm run dev           - watch mode
//
// ═══════════════════════════════════════════════════════════════════════════════

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// ═══════════════════════════════════════════════════════════════════════════════
// Stimulus Application Setup
// ═══════════════════════════════════════════════════════════════════════════════

const application = Application.start()
application.debug = false // production mode
window.Stimulus = application

// ═══════════════════════════════════════════════════════════════════════════════
// LANDING CONTROLLERS (только нужные для welcome страницы)
// ═══════════════════════════════════════════════════════════════════════════════

// UI controllers для landing page
import FloatingChannelsController from "./controllers/ui/floating_channels_controller"
import FloatingDropdownController from "./controllers/ui/floating_dropdown_controller"
import MonkeyJugglerController from "./controllers/ui/monkey_juggler_controller"
import RotatingTextController from "./controllers/ui/rotating_text_controller"

// Manifesto redesign controllers (welcome page)
import WebglBlobsController from "./controllers/ui/manifesto/webgl_blobs_controller"
import MagneticController from "./controllers/ui/manifesto/magnetic_controller"
import TextRevealController from "./controllers/ui/manifesto/text_reveal_controller"

// Manifesto v2 controllers (2026-04-20)
import CounterUpController from "./controllers/ui/manifesto/counter_up_controller"
import MarqueeController from "./controllers/ui/manifesto/marquee_controller"
import StickyHorizontalController from "./controllers/ui/manifesto/sticky_horizontal_controller"
import CursorLightController from "./controllers/ui/manifesto/cursor_light_controller"
import TiltController from "./controllers/ui/manifesto/tilt_controller"
// Manifesto v3 controllers (2026-04-30) — library-based wrappers (motion, gsap, countup.js, canvas-confetti)
import ConfettiV3Controller         from "./controllers/ui/manifesto/confetti_v3_controller"
import CounterUpV3Controller        from "./controllers/ui/manifesto/counter_up_v3_controller"
import MagneticV3Controller         from "./controllers/ui/manifesto/magnetic_v3_controller"
import TextRevealV3Controller       from "./controllers/ui/manifesto/text_reveal_v3_controller"
import StickyHorizontalV3Controller from "./controllers/ui/manifesto/sticky_horizontal_v3_controller"

// Pricing calculator для /calc страницы
import PricingCalculatorController from "./controllers/pricing_calculator_controller"

// Consent Banner (Cookie consent GDPR/152-ФЗ)
import ConsentBannerController from "./controllers/consent_banner_controller"

// CRM Landing Page — JS is inline in crm.html.erb

// ═══════════════════════════════════════════════════════════════════════════════
// Register Controllers
// ═══════════════════════════════════════════════════════════════════════════════

application.register("ui--floating-channels", FloatingChannelsController)
application.register("ui--floating-dropdown", FloatingDropdownController)
application.register("ui--monkey-juggler", MonkeyJugglerController)
application.register("ui--rotating-text", RotatingTextController)
application.register("ui--manifesto--webgl-blobs", WebglBlobsController)
application.register("ui--manifesto--magnetic", MagneticController)
application.register("ui--manifesto--text-reveal", TextRevealController)
application.register("ui--manifesto--counter-up", CounterUpController)
application.register("ui--manifesto--marquee", MarqueeController)
application.register("ui--manifesto--sticky-horizontal", StickyHorizontalController)
application.register("ui--manifesto--cursor-light", CursorLightController)
application.register("ui--manifesto--tilt", TiltController)

// Manifesto v3 wrappers
application.register("ui--manifesto--confetti-v3",          ConfettiV3Controller)
application.register("ui--manifesto--counter-up-v3",        CounterUpV3Controller)
application.register("ui--manifesto--magnetic-v3",          MagneticV3Controller)
application.register("ui--manifesto--text-reveal-v3",       TextRevealV3Controller)
application.register("ui--manifesto--sticky-horizontal-v3", StickyHorizontalV3Controller)
application.register("pricing-calculator", PricingCalculatorController)
application.register("consent-banner", ConsentBannerController)

// CRM Landing Page — registrations moved inline to crm.html.erb

// ═══════════════════════════════════════════════════════════════════════════════
// Exports
// ═══════════════════════════════════════════════════════════════════════════════

export { application }

console.log("[Landing] Loaded", Object.keys(application.router.modulesByIdentifier).length, "controllers")
